import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import { useDebounce } from "../utils";
import { itemTitlePlural } from "../utils/constant";

export const SEARCH_FILTER_OPTIONS = [
  { key: "program", name: itemTitlePlural },
  { key: "provider", name: "Provider" },
  { key: "medical_assistant", name: "MA" },
  { key: "hta", name: "HTA" },
];

export function useGlobalSearch() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [searchType, setSearchType] = useState("program");
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(false);
  const debouncedSearch = useDebounce(search, 300);

  const handleSearchChange = (value) => {
    setSearch(value);
    if (!value) {
      setSearchData([]);
    }
  };

  const handleSearchTypeChange = (key) => {
    setSearchType(key);
    setSearchData([]);
  };

  const resetSearch = () => {
    setSearch("");
    setSearchData([]);
    setSearchType("program");
  };

  const getResultName = (item) =>
    searchType === "program" ? item.program_name : item.name;

  const getResultUrl = (item) => {
    if (searchType === "program") {
      return `/program-details/${item.id}`;
    }

    const memberTabs = ["provider", "medical_assistant", "hta"];
    if (memberTabs.includes(searchType)) {
      return `/members?tab=${searchType}`;
    }

    return "/members";
  };

  const navigateToResult = (item, { onBeforeNavigate } = {}) => {
    const url = getResultUrl(item);
    onBeforeNavigate?.();
    resetSearch();
    navigate(url);
  };

  useEffect(() => {
    if (!debouncedSearch) return;

    const fetchSearchResults = async () => {
      try {
        setLoading(true);
        const response = await api.get(
          `globalsearch?keyword=${searchType}&search=${debouncedSearch}`
        );
        if (response.status === 200 && response.data) {
          setSearchData(response.data);
        }
      } catch {
        setSearchData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSearchResults();
  }, [debouncedSearch, searchType]);

  return {
    search,
    searchType,
    searchData,
    loading,
    filterOptions: SEARCH_FILTER_OPTIONS,
    handleSearchChange,
    handleSearchTypeChange,
    getResultName,
    getResultUrl,
    navigateToResult,
    resetSearch,
  };
}
